const MONTH_DAY_START = 5;

export function formatBatchShort(batch: string): string {
  return batch.slice(MONTH_DAY_START).split("-").reverse().join("/");
}

export function pluralizeDays(days: number): string {
  return `${days} ${days === 1 ? "dia" : "dias"}`;
}
